import { db, auth } from './firebase';
import { collection, doc, writeBatch, serverTimestamp } from 'firebase/firestore';

// Every delete in the app goes through here: the document is copied into `recycleBin`
// with who deleted it and when, and only then removed from its own collection. That way
// nothing is ever really lost -- the Recycle Bin page can list it and restore it.
//
// The saved shape has to match what RecycleBin.js's handleRestore expects: it strips
// the metadata fields below and writes whatever is left back to originalCollection
// under originalId.
//
// ---- আগে এটা addDoc(recycleBin) আর deleteDoc(original) দুইটা আলাদা কল দিয়ে করা হতো --
// দুইটার মাঝে নেটওয়ার্ক কেটে গেলে বা কোনো এরর হলে, আইটেমটা Recycle Bin-এ কপি হয়ে যেত
// কিন্তু আসল কালেকশনে তখনও লাইভ থেকে যেত -- একই জিনিস দুই জায়গায় দেখা যেত, বিভ্রান্তিকর।
// writeBatch দিয়ে দুটো অপারেশন এখন একসাথে, atomic ভাবে হয়: হয় দুটোই সফল হবে, নাহলে
// কোনোটাই হবে না। ----
export const deleteToRecycleBin = async ({ collectionName, id, data, label, reason }) => {
  const { id: _ignoredId, ...fields } = data || {};
  const batch = writeBatch(db);
  const binRef = doc(collection(db, 'recycleBin')); // addDoc যেভাবে অটো-আইডি বানাতো, সেভাবেই
  batch.set(binRef, {
    ...fields,
    originalCollection: collectionName,
    originalId: id,
    deletedItemType: label || collectionName,
    deletedBy: auth.currentUser?.email || 'unknown',
    deletedAt: serverTimestamp(),
    ...(reason ? { reason } : {})
  });
  batch.delete(doc(db, collectionName, id));
  await batch.commit();
};
